import { useTranslation } from 'react-i18next';
import { IFrame } from 'src/components/ui/GlobalComponents/IFrame/IFrame';
import { PageHeader } from 'src/components/ui/GlobalComponents/PageHeader/PageHeader';
import useUser from 'src/hook/data/useUser';
import { GetRazorSiteUrl } from 'src/utils/URLUtils';
import styles from './Comparison.module.scss';

export const Comparison = () => {
    const { t } = useTranslation();
    const { userInfo } = useUser();

    return (
        <div className={styles.comparison}>
            <PageHeader title={t('12 Reasons to join')} />
            <IFrame
                src={GetRazorSiteUrl('pro/subscription-comparison', userInfo?.Token)}
            />
        </div>
    );
}; 